module.exports = __webpack_public_path__ + "media/begin.30ad93c1.mp3";